import { render, staticRenderFns } from "./IconReorder.vue?vue&type=template&id=e1d97662&"
import script from "./IconReorder.vue?vue&type=script&lang=js&"
export * from "./IconReorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports